import { useMediaQuery } from '@mui/material'

import Icon from '@f/elements/Icon/Icon'

export const CHAT_BUTTON_TEXT = 'KI Chat starten'

const MOBILE_CHAT_BUTTON_TEXT = 'KI Chat'

export const RobotIcon = () => {
  const isMobileView = useMediaQuery('(max-width: 901px)')

  return (
    <div className='f-d-flr f-fl-j-ce f-fl-al-ce f-fl-gap-010'>
      <p
        className='f-t-mini f-t-bold'
        style={{
          color: 'var(--branding-font-color)',
          margin: '0'
        }}>
        {isMobileView ? MOBILE_CHAT_BUTTON_TEXT : CHAT_BUTTON_TEXT}
      </p>

      <Icon
        icon='robot-16px'
        className='f-icon-030 f-icon-st-010 f-m-r-005 f-c-st-inherit'
        style={{
          color: 'var(--branding-font-color)'
        }}
      />
    </div>
  )
}

export const SendIcon = () => {
  return (
    <Icon
      icon='right-arrow-16px'
      className='f-icon-025 f-m-r-005 f-c-st-inherit'
      style={{
        color: 'var(--branding-main-color)'
      }}
    />
  )
}
